import { useState } from "react";
import { Calculator, Clock, Coins, FileCheck2, Gauge, Search } from "lucide-react";

const BENEFITS = [
  { icon: Search, title: "Trovi un utensile in dieci secondi", text: "Magazzino, posizione fisica e giacenza per ogni referenza: chi cerca non chiede più a chi c'era ieri." },
  { icon: Clock, title: "Nessun fermo per un utensile mancante", text: "Scorte minime per magazzino, proposte di riordino e ordini al fornitore partono prima che il tagliente finisca." },
  { icon: Coins, title: "Costo per pezzo reale, non stimato", text: "Taglienti consumati, ore macchina, ore operatore, attrezzaggio e materiale entrano nel costo industriale del componente." },
  { icon: Gauge, title: "Planning che regge la settimana", text: "Carichi per macchina e reparto, colli di bottiglia in evidenza, ore reali timbrate in officina." },
  { icon: FileCheck2, title: "Audit con le prove già dentro", text: "Piani di controllo per fase, quote misurate con lo strumento tarato, non conformità e azioni correttive tracciate." },
];

const euro = (value) => value.toLocaleString("it-IT", { maximumFractionDigits: 0 });

export function BenefitsSection() {
  const [hours, setHours] = useState(2);
  const [rate, setRate] = useState(70);

  const weekly = Math.max(hours, 0) * Math.max(rate, 0);
  const yearly = weekly * 46;

  return (
    <section className="landing-benefits" id="benefici" data-testid="landing-benefits">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">BENEFICI <i /> MISURABILI</p>
        <h2>Cosa cambia in officina, in concreto</h2>
        <p className="landing-desc">
          Nessuna promessa in percentuale: sotto trovi il calcolatore del fermo macchina, con i tuoi numeri.
        </p>
      </div>

      <div className="landing-benefit-layout">
        <ul className="landing-benefit-list">
          {BENEFITS.map(({ icon: Icon, title, text }, index) => (
            <li
              className="landing-reveal"
              style={{ transitionDelay: `${index * 70}ms` }}
              key={title}
              data-testid={`landing-benefit-${index + 1}`}
            >
              <Icon size={19} />
              <div>
                <b>{title}</b>
                <p>{text}</p>
              </div>
            </li>
          ))}
        </ul>

        <aside className="landing-calc landing-reveal" data-testid="downtime-calculator">
          <p className="demo-form-title"><Calculator size={16} /> Quanto ti costa il fermo macchina</p>
          <label>
            Ore di fermo alla settimana
            <input
              type="number"
              min="0"
              max="80"
              step="0.5"
              value={hours}
              onChange={(event) => setHours(Number(event.target.value))}
              data-testid="calc-hours-input"
            />
          </label>
          <label>
            Tariffa oraria della macchina (€/h)
            <input
              type="number"
              min="0"
              max="1000"
              step="1"
              value={rate}
              onChange={(event) => setRate(Number(event.target.value))}
              data-testid="calc-rate-input"
            />
          </label>
          <div className="landing-calc-out">
            <p><span>Alla settimana</span><b data-testid="calc-weekly">{euro(weekly)} €</b></p>
            <p className="is-year"><span>All'anno (46 settimane lavorate)</span><b data-testid="calc-yearly">{euro(yearly)} €</b></p>
          </div>
          <p className="landing-calc-note">
            Stima con i tuoi dati: ore × tariffa oraria. Serve a mettere in scala il costo di un utensile
            introvabile, non a promettere risultati.
          </p>
        </aside>
      </div>
    </section>
  );
}
